import React, { useState } from 'react';
import '../../styles/login.css';
import { passwordRecoveryUser } from '../../services/player/LoginService.tsx';
import { Link } from 'react-router-dom';

const PasswordRecovery = () => {
  const [email, setEmail] = useState('');
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    await passwordRecoveryUser(email);
    setEmail('');
    setShowSuccessMessage(true);
  };

  return (
    <div className='bodylogin'>
      <div className="logincontainer shadow-lg">
        <h2 className='title teko'>Enter your email</h2>
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <input type="email" name='email' value={email} required onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div id="liveAlertPlaceholder">
            <button type="submit" className='buttonlogin' id="liveAlertBtn">Verify</button>
            <Link to="/" className='buttonBack'>Go back</Link>
          </div>
        </form>
        {showSuccessMessage && (
          <div className="alert alert-success mt-3" role="alert">
            If your email is registered, one of the administrators will contact you for your password.
            </div>
        )}
      </div>
    </div>
  );
};


export default PasswordRecovery;